import classNames from 'classnames';
import { memo } from 'react';

import dateService from '@gem/services/date-service';

import styles from './styles.m.css';

const Time = ({ time, fixedColor = false }) => {
  if (!time) {
    return null;
  }

  return (
    <span
      className={classNames(styles.time, {
        [styles.fixedColor]: fixedColor,
      })}
    >
      {dateService.format(time, {
        hour: 'numeric',
        minute: 'numeric',
      })}
    </span>
  );
};

export default memo(Time);
